import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/40.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Mały rynek"
            question="Dokąd chcesz iść?"
            audio={audio}
            answers={{
                ans1: "Do karczmy pani Jasińskiej.",
            }}
            links={{
                link1: PAGES.p87,
            }}
            content={
                <div>
                    <p>
                        Mały rynek – małe zakupy. Ludzie tłoczą się wokół stoisk, a czego tu nie ma! Osełki sera zawinięte w liść chrzanu, masło, w którym sprzedawcy wyrzeźbili wzorki gorącą łyżką, wiklinowe koszyki pełne jajek. Koszyki identyczne jak te, w których Emil wiózł śliwki. Widocznie tutaj się tak wyplata, w końcu materiału wokół rzeki jest pod dostatkiem.
                    </p>
                    <ul>
                        <li>Pierdziołki dojrzałe, pierdziołki! – krzyczy kobieta w chuście nad stołem pełnym gruszek ulęgałek. Inni sprzedawcy też mają owoce. Przy jednym ze straganów widzisz kobietę z synem w kipie.</li>
                        <li>Mamo, zegarek mi upadł!</li>
                        <li>O nie, Jankele! Nie płacz! Lepiej idź i sprawdź, czy zegarek jeszcze chodzi!</li>
                        <li>Czy jeszcze chodzi? Nie, nie chodzi! Leży na ziemi!</li>
                        <li>Och, Jankele!</li>
                    </ul>
                </div>
            }
        />

    );
}